import { useSelector } from 'react-redux';

const useSearch = (allFields) => {
    const searchQuery = useSelector((state) => state.settings.searchQuery);

    if (!searchQuery) {
        return allFields;
    } else {
        const searchQueryLC = searchQuery.toLowerCase();
        const filteredFields = {};
        for (const tab in allFields) {
            if (allFields[tab].name.toLowerCase().includes(searchQueryLC)) {
                filteredFields[tab] = allFields[tab];
                continue;
            }
            const tabFields = allFields[tab].fields;
            for (const fieldId in tabFields) {
                const field = tabFields[fieldId];
                if (isMatched(field, searchQueryLC)) {
                    addToFilteredFields(allFields, filteredFields, tab, fieldId, field);
                } else if (Array.isArray(field.value)) {
                    if (field.value.length > 0) {
                        const firstVal = field.value[0];
                        if (typeof firstVal === 'string') {
                            for (const value of field.value) {
                                if (value.toLocaleLowerCase().includes(searchQueryLC)) {
                                    addToFilteredFields(allFields, filteredFields, tab, fieldId, field);
                                    break;
                                }
                            }
                        } else {
                            for (const arrayField in firstVal) {
                                if (isMatched(firstVal[arrayField], searchQueryLC)) {
                                    addToFilteredFields(allFields, filteredFields, tab, fieldId, field);
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }
        return filteredFields;
    }
};

function isMatched(field, query) {
    if (!field.searchable) {
        return false;
    }
    return (
        (field.name && field.name.toLowerCase().includes(query)) ||
        (field.tags && field.tags.find((t) => t.toLowerCase().includes(query)))
    );
}

function addToFilteredFields(allFields, filteredFields, tab, fieldId, field) {
    if (!filteredFields[tab]) {
        filteredFields[tab] = {
            ...allFields[tab],
            fields: {}
        };
    }
    filteredFields[tab].fields[fieldId] = field;
}

export default useSearch;
